import { useEffect } from 'react'
import {
  IoIosWarning,
  IoIosClose,
  IoIosCheckmarkCircle,
  IoIosInformation,
} from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { removeMessageFromSnackbar } from '../../redux/slices'
import Text from './Text'

const icons = {
  error: IoIosWarning,
  success: IoIosCheckmarkCircle,
  info: IoIosInformation,
  warning: IoIosWarning,
}

const bgColors = {
  error: 'bg-ERROR-600',
  success: 'bg-SUCCESS-600',
  info: 'bg-INFO-600',
  warning: 'bg-WARNING-600',
}

const textColors = {
  error: 'text-ERROR-200',
  success: 'text-SUCCESS-200',
  info: 'text-INFO-200',
  warning: 'text-WARNING-200',
}

const Snackbar = () => {
  const dispatch = useDispatch()
  const { messages } = useSelector((s) => s.snackbar)

  useEffect(() => {
    messages.forEach((message) => {
      const timer = setTimeout(() => {
        dispatch(removeMessageFromSnackbar(message.id))
      }, message.autoHideDuration || 3000)

      return () => clearTimeout(timer)
    })
  }, [messages, dispatch])

  if (messages.length === 0) return null

  return (
    <div className="fixed top-2 left-2 right-2 z-[999] flex flex-col gap-3 max-w-lg lg:max-w-xl mx-auto">
      {messages?.map((message) => {
        const Icon = icons[message.type]
        return (
          <div
            key={message.id}
            className={`flex items-center justify-between gap-3 ${bgColors[message.type]} px-4 py-3 rounded-2 text-text-primary-on-brand`}
          >
            <div className="flex gap-3 items-center">
              <Icon size={30} />
              <div>
                <Text
                  tag="p"
                  variant="title"
                  size="medium"
                  className="text-text-primary-on-brand"
                >
                  {message.type.charAt(0).toUpperCase() + message.type.slice(1)}
                </Text>
                <Text
                  tag="p"
                  variant="label"
                  size="medium"
                  className={textColors[message.type]}
                >
                  {message.message}
                </Text>
              </div>
            </div>
            <IoIosClose
              size={28}
              className="cursor-pointer"
              onClick={() => dispatch(removeMessageFromSnackbar(message.id))}
            />
          </div>
        )
      })}
    </div>
  )
}

export default Snackbar
